// extracted by mini-css-extract-plugin
module.exports = {"stat":"BulletinsRow_stat__1C3VD","statIcon":"BulletinsRow_statIcon__3Z-MK"};